<template>
  <div id="OcrExpenseAccount" class="fullheight">
    <div class="ocrTree">
      <el-input placeholder="输入关键字进行过滤" clearable v-model="filterText">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <el-tree class="filter-tree" :data="dicDatas" :props="defaultProps" default-expand-all :filter-node-method="filterNode" ref="tree">
        <div
          class="custom-tree-node"
          slot-scope="{ node, data }"
          @click="showDetail(data)"
          style="font-size: 10px"
          @mouseenter="data.show = true"
          @mouseleave="data.show = false"
        >
          <!--                    <img class="custom-imgDingtalk" src="/img/dingtalk.png" alt=""></img>-->
          <span class="show-ellipsis" :title="node.label">{{ node.label }}</span>
          <span class="is_deploy" v-show="data.is_deploy == true">已配置规则</span>
          {{ data.show }}
          <el-dropdown v-show="data.isParent == 'false'" @command="handleCommand" class="el-dropdown_data">
            <span class="el-dropdown-link">
              <img src="@/assets/img/iconMore.png" class="iconMore" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-show="data.is_deploy != true" icon="el-icon-plus" :command="{ node: node, data, action: 'add' }">添加 </el-dropdown-item>
              <el-dropdown-item v-show="data.is_deploy == true" icon="el-icon-edit" v-if="data.parentId != '0'" :command="{ node: node, data, action: 'edit' }"
                >编辑
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-delete"
                v-show="data.is_deploy == true"
                v-if="data.parentId != '0'"
                :command="{ node: node, data, action: 'delete' }"
                divided
                >删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tree>
    </div>
    <div class="ocrTreeDetail">
      <div v-if="showOcrTreeDetail">
        <div class="el-breadcrumb__inner is-link title_tree drawerTitle">
          <span>{{ drawerTitle }}</span>
        </div>
        <el-form class="showOcrTreeDetail" ref="form" :model="show_form" size="mini" label-position="left">
          <el-form-item label="发票明细为:" style="margin-top: 15px">
            <div slot="label" style="display: flex; align-items: center">
              <div class="labelElTag"></div>
              <span style="padding-left: 8px; padding-right: 2px">发票明细为</span>
              <span style="padding-left: 2px">:</span>
            </div>
            <span v-for="(item, index) in show_form.details" :key="index">
              <el-tag class="elTag" size="small"> {{ item.name }}</el-tag>
            </span>
            <span
              >共<span style="color: #00a0e9; padding: 0 3px">{{ show_form.details.length }}</span
              >项</span
            >
          </el-form-item>

          <el-form-item label="发票类型为:">
            <div slot="label" style="display: flex; align-items: center">
              <div class="labelElTag"></div>
              <span style="padding-left: 8px; padding-right: 2px">发票类型为:</span>
            </div>
            <span v-for="(item, index) in show_form.OcrBillType" :key="index">
              <el-tag class="elTag" size="small"> {{ item.name }}</el-tag>
            </span>
            <span
              >共<span style="color: #00a0e9; padding: 0 3px">{{ show_form.OcrBillType.length }}</span
              >项</span
            >
          </el-form-item>

          <el-form-item label="第三方流水为:">
            <div slot="label" style="display: flex; align-items: center">
              <div class="labelElTag"></div>
              <span style="padding-left: 8px; padding-right: 2px">第三方流水为:</span>
            </div>
            <span v-for="(item, index) in show_form.flows" :key="index">
              <el-tag class="elTag" size="small"> {{ item.name }}</el-tag>
            </span>
            <span
              >共<span style="color: #00a0e9; padding: 0 3px">{{ show_form.flows.length }}</span
              >项</span
            >
          </el-form-item>
          <el-form-item label="成本科目为:">
            <div slot="label" style="display: flex; align-items: center">
              <div class="labelElTag"></div>
              <span style="padding-left: 8px; padding-right: 2px">成本科目为:</span>
            </div>
            <span v-for="(item, index) in show_form.accountRule" :key="index">
              <el-tag class="elTag" size="small"> {{ `${item.cost_name} - ${item.template_pathLabels ? item.template_pathLabels.join(',') : ''}` }}</el-tag>
            </span>
            <span
              >共<span style="color: #00a0e9; padding: 0 3px">{{ show_form.accountRule.length }}</span
              >项</span
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-drawer
      :title="drawerTitle"
      :before-close="handleClose"
      :visible.sync="dialog"
      direction="rtl"
      custom-class="demo-drawer"
      class="sideDrawer"
      ref="drawer"
      width="28%"
    >
      <div class="demo-drawer__content">
        <el-form :model="form">
          <span class="ocr_title">OCR费用科目智能生成规则</span>
          <div class="from_tab">
            <div class="el-breadcrumb__inner is-link title_tree">
              <span>发票明细为: (共{{ form.details.length }}项)</span>
            </div>
            <el-form-item class="el-form_invoice" v-for="(item, key) in form.details" :key="key">
              <el-input
                maxlength="10"
                size="medium"
                style="width: 300px"
                placeholder="请输入发票明细"
                v-model="item.name"
                clearable
                @blur="entBlurDetails(item)"
              ></el-input>
              <i class="el-icon-delete el-form_i" @click="handleDelete(key, item)"></i>
            </el-form-item>

            <el-button style="width: 300px" size="small" @click="addDetails()" icon="el-icon-plus"> 添加 </el-button>
          </div>
          <div class="from_tab">
            <div class="el-breadcrumb__inner is-link title_tree">
              <span>发票类型为: (共{{ form.OcrBillType.length }}项)</span>
            </div>

            <el-form-item class="el-form_invoice" v-for="(item, key) in form.OcrBillType" :key="key">
              <el-select style="width: 300px" v-model="item.type" clearable @change="ocrBillTypeChange(item)" placeholder="请选择发票类型">
                <el-option label="增值税发票" value="1"></el-option>
                <el-option label="火车票" value="2"></el-option>
                <el-option label="机票行程单" value="3"></el-option>
                <el-option label="出租车票" value="4"></el-option>
                <el-option label="定额发票" value="5"></el-option>
                <el-option label="增值税发票卷票" value="6"></el-option>
                <el-option label="过路过桥费发票" value="7"></el-option>
              </el-select>
              <i class="el-icon-delete el-form_i" @click="typeDelete(key, item)"></i>
            </el-form-item>

            <el-button style="width: 300px" size="small" @click="addTypeDetails()" icon="el-icon-plus"> 添加 </el-button>
          </div>
          <div class="from_tab">
            <div class="el-breadcrumb__inner is-link title_tree">
              <span>第三方流水为: (共{{ form.flows.length }}项)</span>
            </div>

            <el-form-item class="el-form_invoice" v-for="(item, key) in form.flows" :key="key">
              <el-input
                size="small"
                style="width: 300px"
                maxlength="15"
                clearable
                placeholder="请输入第三方流水"
                @blur="entBlurFlows(item)"
                v-model="item.name"
              ></el-input>
              <i class="el-icon-delete el-form_i" @click="flowsDelete(key, item)"></i>
            </el-form-item>

            <el-button style="width: 300px" size="small" @click="addFlows()" icon="el-icon-plus"> 添加 </el-button>
          </div>
          <span class="ocr_title">进项税计算规则</span>
          <div class="from_tab">
            <div class="el-breadcrumb__inner is-link title_tree">
              <span>是否抵扣:</span>
            </div>
            <el-form-item>
              <el-radio-group v-model="form.is_deduct">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="from_tab">
            <div class="el-breadcrumb__inner is-link title_tree">
              <span>默认税率(%):</span>
            </div>
            <el-form-item>
              <el-input-number
                v-model="form.default_tax_rate"
                :controls="false"
                style="width: 300px"
                :min="0"
                :max="13"
                placeholder="最大13%，默认0，不能为负"
              ></el-input-number>
            </el-form-item>
          </div>
          <!-- 进项税计算公式 -->
          <div class="from_tab" v-if="expenseAccountRuleVo.dic_key === 'jpf'">
            <div class="el-breadcrumb__inner is-link title_tree">
              <span>进项税计算公式:</span>
            </div>
            <el-row>
              <el-col :span="20">
                <el-input v-model="form.formula" type="textarea" @blur="blurEvent"></el-input>
              </el-col>
              <el-col :span="4">
                <form-field-selector deumKey="AirTineraryField" @setField="(params) => setField(params)"></form-field-selector>
              </el-col>
            </el-row>
          </div>
          <!-- 成本科目 -->
          <span class="ocr_title">成本科目</span>
          <div class="from_tab" style="width: 450px">
            <el-table :data="form.accountRule" max-height="490">
              <el-table-column width="200" label="成本科目模版">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.template_id" placeholder="请选择" @change="getTempListById(scope.row, scope.$index)">
                    <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="200" label="成本科目">
                <template slot-scope="scope">
                  <el-cascader
                    :ref="`cascader${scope.$index}`"
                    v-model="scope.row.template_account_path"
                    :props="{
                      value: 'key',
                      label: 'name'
                    }"
                    :show-all-levels="false"
                    :options="scope.row.templateAccountList"
                    @change="(params) => handleKmDataChange(params, scope.row, `cascader${scope.$index}`)"
                  ></el-cascader>
                </template>
              </el-table-column>
              <el-table-column align="center" width="50" label="操作">
                <template slot-scope="scope">
                  <el-link type="primary" :underline="false" @click="removeAcountRule(scope.$index)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
            <el-button style="width: 300px" size="small" @click="addAccountRule()" icon="el-icon-plus"> 添加 </el-button>
          </div>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="submiteditModelFormData(form)" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }} </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import formFieldSelector from '@/views/system/noticeRules/formFieldSelector.vue'
import sysType from '@/api/sysType'
import req from '@/request'
const business = req.getContext().business
export default {
  components: {
    formFieldSelector
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  data() {
    return {
      lists: {},
      filterText: '',
      dicDatas: [],
      dialog: false,
      loading: false,
      showOcrTreeDetail: false,
      BILL_TYPE: [
        { key: '1', name: '增值税发票' },
        { key: '2', name: '火车票' },
        { key: '3', name: '机票行程单' },
        { key: '4', name: '出租车票' },
        { key: '5', name: '定额发票' },
        { key: '6', name: '增值税发票卷票' },
        { key: '7', name: '过路过桥费发票' }
      ],
      form: {
        details: [],
        OcrBillType: [],
        flows: [],
        accountRule: [],
        default_tax_rate: 0,
        is_deduct: '1',
        formula: ''
      },
      show_form: {
        details: [],
        OcrBillType: [],
        flows: [],
        accountRule: [],
        default_tax_rate: 0,
        is_deduct: '1',
        formula: ''
      },
      drawerTitle: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      expenseAccountRuleVo: {
        dic_key: '',
        invoice_details: '',
        invoice_types: '',
        thirdparty_flows: '',
        sub_expense_account_rule_detail: ''
      },
      treeData: [],
      blurIndex: 0,
      showData: {}
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    //input框记录光标位置
    blurEvent(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    //变量选择
    setField(val) {
      let str = '{' + val.label + ':' + val.value + '}'
      this.form.formula = this.form.formula.slice(0, this.blurIndex) + str + this.form.formula.slice(this.blurIndex)
    },
    async showDialog(data, action) {
      this.form = {
        details: [],
        OcrBillType: [],
        flows: [],
        accountRule: [],
        default_tax_rate: 0,
        is_deduct: '1',
        action: 'add',
        formula: ''
      }
      if (data.key === 'jpf' && action === 'add') {
        this.form.formula = '({票价:JPJG}+{燃油附加费:RYFJF})/1.09*0.09'
        this.expenseAccountRuleVo.formula = '({票价:JPJG}+{燃油附加费:RYFJF})/1.09*0.09'
      }
      this.dialog = true
      this.drawerTitle = data.name
      this.expenseAccountRuleVo.dic_key = data.key
      if (action == 'edit') {
        this.form = {
          details: [],
          OcrBillType: [],
          flows: [],
          accountRule: [],
          default_tax_rate: 0,
          is_deduct: '1',
          action: 'edit',
          formula: ''
        }
        let Value = data.deploy_value
        let arrar0 = JSON.parse(Value)[0]
        if (arrar0.invoice_details) {
          let invoiceDetails = arrar0.invoice_details.split(',')
          invoiceDetails.forEach((detail) => {
            this.form.details.push({
              name: detail
            })
          })
        }
        if (arrar0.invoice_types) {
          let invoiceTypes = arrar0.invoice_types.split(',')
          invoiceTypes.forEach((detail) => {
            this.form.OcrBillType.push({
              type: detail,
              name: this.formatDetail(detail)
            })
          })
        }
        if (arrar0.thirdparty_flows) {
          let thirdpartyFlows = arrar0.thirdparty_flows.split(',')
          thirdpartyFlows.forEach((detail) => {
            this.form.flows.push({
              name: detail
            })
          })
        }
        if (arrar0.sub_expense_account_rule_detail) {
          this.form.accountRule = arrar0.sub_expense_account_rule_detail
          this.form.accountRule.forEach(async (item, index) => {
            item.template_account_name = JSON.parse(item.template_account_name)
            if (item.template_account_name) {
              item.template_account_key = item.template_account_name.valueLast
              item.template_account_path = item.template_account_name.value
            }
            await this.getTempListById(item, index)
          })
        }
        this.form.default_tax_rate = arrar0.default_tax_rate
        this.form.formula = arrar0.formula
        this.form.is_deduct = arrar0.is_deduct.toString()
        this.expenseAccountRuleVo.id = arrar0.id
      }
    },
    delSysType(data) {
      let _me = this
      this.$confirm(`是否确定删除 [${data.name}] 配置规则?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let Value = data.deploy_value
        let arrar0 = JSON.parse(Value)[0]
        _me.$http
          .remove('${third}' + '/expense_account_rule/' + arrar0.id)
          .then(
            (data) => {
              if (data.data.state) {
                this.$message({
                  type: 'success',
                  message: data.message || '删除成功'
                })
              } else {
                this.$message.error(data.message || '删除成功')
              }
              this.loadData()
              this.showOcrTreeDetail = false
            },
            (error) => {
              this.$message.error(error || '删除失败')
            }
          )
          .catch(() => {
            this.dialogVisible = false
          })
      })
    },
    loadData() {
      this.$http.get('${portal}' + '/sys/sysType/v1/getJson?id=fykm').then((res) => {
        this.lists = {
          id: res.data.id,
          name: '费用类型',
          isParent: 'true',
          key: 'fykm',
          open: 'true',
          text: '费用类型',
          typeId: res.data.id,
          deleted: 0,
          children: []
        }
        this.getTreeData()
        this.$http.get('${third}' + '/expense_account_rule/getFykm').then((data) => {
          this.dicDatas = this.formatTreeData(data.data)
        })
      })
    },
    getTreeData() {
      let params = {
        pageBean: {
          page: 1,
          pageSize: 10,
          showTotal: true
        }
      }
      sysType.getCostAccountTemplate(params).then((data) => {
        this.treeData = data
      })
    },
    afterSaveData() {
      this.expenseAccountRuleVo = {
        dic_key: '',
        invoice_details: '',
        invoice_types: '',
        thirdparty_flows: '',
        default_tax_rate: '',
        is_deduct: '',
        formula: ''
      }
      this.loading = false
      this.dialog = false
      this.loadData()
    },
    handleCommand(command) {
      let data = command.data
      let action = command.action
      switch (action) {
        case 'add':
          this.showDialog(data, action)
          break
        case 'edit':
          this.showDialog(data, action)
          break
        case 'delete':
          this.delSysType(data)
          break
        case 'moveto':
          this.$message('暂未提供该功能')
          break
        default:
          break
      }
    },
    formatTreeData(jsonData) {
      jsonData.push(this.lists)
      var result = [],
        temp = {},
        i = 0,
        j = 0,
        len = jsonData.length
      for (; i < len; i++) {
        temp[jsonData[i]['id']] = jsonData[i] // 以id作为索引存储元素，可以无需遍历直接定位元素
      }
      for (; j < len; j++) {
        var currentElement = jsonData[j]
        var tempCurrentElementParent = temp[currentElement['parentId']] // 临时变量里面的当前元素的父元素
        if (tempCurrentElementParent) {
          // 如果存在父元素
          if (!tempCurrentElementParent['children']) {
            // 如果父元素没有chindren键
            tempCurrentElementParent['children'] = [] // 设上父元素的children键
          }
          tempCurrentElementParent['children'].push(currentElement) // 给父元素加上当前元素作为子元素
        } else {
          // 不存在父元素，意味着当前元素是一级元素
          result.push(currentElement)
        }
      }
      return result
    },
    handleDelete(index, row) {
      this.form.details.splice(index, 1)
    },
    flowsDelete(index) {
      this.form.flows.splice(index, 1)
    },
    typeDelete(index, row) {
      this.form.OcrBillType.splice(index, 1)
    },
    addDetails() {
      if (this.form.details.length >= 20) {
        this.$message.info('最多可以添加20条!')
        return
      }
      let invoice_details = {
        name: ''
      }
      this.form.details.push(invoice_details)
    },
    addTypeDetails() {
      if (this.form.OcrBillType.length >= 6) {
        this.$message.info('最多可以添加6条!')
        return
      }
      let invoice_type = {
        type: ''
      }
      this.form.OcrBillType.push(invoice_type)
    },
    addFlows() {
      if (this.form.flows.length >= 20) {
        this.$message.info('最多可以添加20条!')
        return
      }
      let invoice_flows = {
        name: ''
      }
      this.form.flows.push(invoice_flows)
    },
    addAccountRule() {
      if (this.form.accountRule.length >= 20) {
        this.$message.info('最多可以添加20条!')
        return
      }
      this.form.accountRule.push({
        cost_key: this.expenseAccountRuleVo.dic_key,
        templateAccountList: [],
        template_account_key: '',
        template_account_name: '',
        template_account_path: [],
        template_id: ''
      })
    },
    removeAcountRule(index) {
      this.form.accountRule.splice(index, 1)
    },
    async getTempListById(row, index) {
      if (row && row.template_id) {
        let params = {
          parentId: row.template_id,
          tenantId: this.tenantId
        }
        const response = await req.request({
          url: `${business}/system/cost_account_template/queryByParentId${req.formatGetUri(params)}`,
          method: 'POST'
        })
        if (response.data) {
          let p = this.deleteChildrenEmpty(response.data)
          this.$set(this.form.accountRule[index], 'templateAccountList', p)
        }
      }
    },
    deleteChildrenEmpty(p) {
      return p.map((items) => {
        if (items.children.length === 0) {
          delete items.children
        } else {
          items.children = this.deleteChildrenEmpty(items.children)
        }
        return items
      })
    },
    handleKmDataChange(val, row, ref) {
      if (val) {
        let node = this.$refs[ref].getCheckedNodes()
        if (node.length > 0) {
          row['template_account_key'] = node[0].value
          row['template_account_name'] = { pathLabels: node[0].pathLabels, valueLast: node[0].value, value: node[0].path }
        }
      }
    },
    handleClose() {
      this.loading = false
      this.dialog = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    entBlurDetails: function (item) {
      if (item.name.indexOf(',') > 0) {
        this.$message.info('不可输入特殊字符!')
        item.name = ''
      }
      let filter = this.form.details.filter((detail) => detail.name == item.name)
      if (filter && filter.length >= 2) {
        this.$message.info('不可重复添加!')
        item.name = ''
      }
    },
    ocrBillTypeChange(item) {
      let filter = this.form.OcrBillType.filter((detail) => detail.type == item.type)
      if (filter && filter.length >= 2) {
        this.$message.info('不可重复添加!')
        item.type = ''
      }
    },
    entBlurFlows: function (item) {
      if (item.name.indexOf(',') > 0) {
        this.$message.info('不可输入特殊字符!')
        item.name = ''
      }
      let filter = this.form.flows.filter((detail) => detail.name == item.name)
      if (filter && filter.length >= 2) {
        this.$message.info('不可重复添加!')
        item.name = ''
      }
    },
    submiteditModelFormData(form) {
      this.loading = true
      let param = this.expenseAccountRuleVo
      let details = []
      form.details.forEach((item, index) => {
        if (item.name) {
          if (index == 0) {
            param.invoice_details = item.name
          } else {
            param.invoice_details = param.invoice_details + ',' + item.name
          }
          details.push(item)
        }
      })
      let OcrBillType = []
      form.OcrBillType.forEach((item, index) => {
        if (item.type) {
          if (index == 0) {
            param.invoice_types = item.type
          } else {
            param.invoice_types = param.invoice_types + ',' + item.type
          }
          item.name = this.formatDetail(item.type)
          OcrBillType.push(item)
        }
      })
      let flows = []
      form.flows.forEach((item, index) => {
        if (item.name) {
          if (index == 0) {
            param.thirdparty_flows = item.name
          } else {
            param.thirdparty_flows = param.thirdparty_flows + ',' + item.name
          }
          flows.push(item)
        }
      })
      let url = '/expense_account_rule/'
      let action = form.action
      param.default_tax_rate = form.default_tax_rate
      param.is_deduct = form.is_deduct
      param.formula = form.formula
      let tempVa = JSON.parse(JSON.stringify(this.form.accountRule))
      param.sub_expense_account_rule_detail = tempVa.map((item) => {
        if (item.template_account_name) {
          item['cost_name'] = this.treeData.find((items) => item.template_id === items.id).name || ''
          item.template_account_key = item.template_account_name.valueLast
          item.template_account_path = item.template_account_name.value
          item.template_pathLabels = item.template_account_name.pathLabels
          item.template_account_name = JSON.stringify(item.template_account_name)
        }
        return item
      })
      if (action == 'add') {
        param.id = ''
        this.$http.post('${third}' + url, param).then((res) => {
          this.afterSaveData()
          this.show_form = form
          this.show_form.details = details
          this.show_form.OcrBillType = OcrBillType
          this.show_form.flows = flows
          this.show_form.accountRule = tempVa.map((item) => {
            if (item.template_account_name) {
              item['cost_name'] = this.treeData.find((items) => item.template_id === items.id).name || ''
              item.template_account_key = item.template_account_name.valueLast
              item.template_account_path = item.template_account_name.value
              item.template_pathLabels = item.template_account_name.pathLabels
              item.template_account_name = JSON.stringify(item.template_account_name)
            }
            return item
          })
        })
      } else {
        this.$http.put('${third}' + url, param).then((res) => {
          this.afterSaveData()
          this.show_form = form
          this.show_form.details = details
          this.show_form.OcrBillType = OcrBillType
          this.show_form.flows = flows
          this.show_form.accountRule = param.sub_expense_account_rule_detail
        })
      }

      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    showDetail(data) {
      this.drawerTitle = data.name
      this.show_form = {
        details: [],
        OcrBillType: [],
        accountRule: [],
        flows: []
      }
      this.showOcrTreeDetail = false
      if (data.is_deploy) {
        let Value = data.deploy_value
        let arrar0 = JSON.parse(Value)[0]
        if (arrar0.invoice_details) {
          let invoiceDetails = arrar0.invoice_details.split(',')
          invoiceDetails.forEach((detail) => {
            this.show_form.details.push({
              name: detail
            })
          })
        }
        if (arrar0.invoice_types) {
          let invoiceTypes = arrar0.invoice_types.split(',')
          invoiceTypes.forEach((detail) => {
            this.show_form.OcrBillType.push({
              type: detail,
              name: this.formatDetail(detail)
            })
          })
        }
        if (arrar0.thirdparty_flows) {
          let thirdpartyFlows = arrar0.thirdparty_flows.split(',')
          thirdpartyFlows.forEach((detail) => {
            this.show_form.flows.push({
              name: detail
            })
          })
        }
        if (arrar0.sub_expense_account_rule_detail) {
          let accountRule = arrar0.sub_expense_account_rule_detail
          accountRule.forEach(async (item) => {
            item['cost_name'] = this.treeData.find((items) => item.template_id === items.id).name || ''
            item.template_account_name = JSON.parse(item.template_account_name)
            if (item.template_account_name) {
              item.template_account_key = item.template_account_name.valueLast
              item.template_account_path = item.template_account_name.value
              item.template_pathLabels = item.template_account_name.pathLabels
            }
          })
          this.show_form.accountRule = accountRule
        }
        this.showOcrTreeDetail = true
      }
    },
    formatDetail(val) {
      let billtype = this.BILL_TYPE.find((item) => {
        if (item.key == val) {
          return item.name
        }
      })
      return billtype.name
    }
  }
}
</script>

<style lang="scss">
#OcrExpenseAccount {
  padding: 20px 0;
}

.drawerTitle {
  margin-top: 25px;
  margin-left: 20px;
}

.ocrTree {
  float: left;
  width: 20%;
  border-right: 1px solid rgb(238, 238, 238);
  height: calc(100% - 20px);
  border-left: 1px solid rgb(238, 238, 238);
  overflow-y: auto;
}

.ocrTreeDetail {
  float: left;
  width: 60%;
  border: 1px solid rgb(238, 238, 238);
  height: 100%;
}

.custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-right: 8px;
}
.custom-tree-node .custom-imgDingtalk {
  width: 18px;
  height: 18px;
}

.custom-tree-node img {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover img {
  visibility: visible;
}

.el-drawer__header {
  margin-bottom: 1px !important;
}
.el-drawer__header > :first-child,
.el-drawer__title {
  font-size: 18px;
  font-weight: bold;
}
.title_tree {
  margin-bottom: 10px;
}

.title_button {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid rgb(238, 238, 238);
  width: 98%;
  margin-left: 1%;
}

.el-drawer__body {
  overflow-y: auto;
  width: 100%;
}

.demo-drawer__footer {
  margin-top: 25px;
  position: fixed;
  bottom: 20px;
  width: 28%;
  text-align: center;
  margin: 0;
}

.demo-drawer-button {
  width: 100%;
}

.is_deploy {
  border: 1px solid #eaeefb;
  font-size: 10px;
  background-color: #fafafa;
  margin-left: 5px;
  padding: 2px 5px;
}

.el-dropdown_data {
  position: absolute;
  right: 10px;
}
.labelElTag {
  height: 7px;
  width: 7px;
  background-color: #00a0e9;
  border: none;
  border-radius: 50%;
}

.elTag {
  margin-right: 5px;
  background-color: #dcdcdc;
  color: #4f4f4f;
  border-radius: 0;
  height: 30px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 13px;
  border: none;
  margin: 5px;
}

.showOcrTreeDetail {
  border: 1px solid rgb(238, 238, 238);
  margin-top: 30px;
  margin-left: 15px;
  padding-left: 30px;
}
.app-box__card[data-v-7ba5bd90] > .el-card__body {
  height: calc(100% - 55px);
  padding: 0 10px 0 20px;
  overflow-y: unset;
}

.from_tab {
  width: 400px;
  margin-left: 85px;
  margin-bottom: 20px;
}
.el-form_invoice {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.el-form_i {
  font-size: 22px;
  margin-left: 10px;
  position: absolute;
  top: 6px;
}
.ocr_title {
  font-weight: bold;
  margin: 10px;
  display: block;
}
</style>
